module.exports = __webpack_public_path__ + "img/7-3.fe89abda.png";